import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import IconShieldExclamation from '@/assets/icons/heroIcons/ShieldExclamation.svg';
import IconChevronDown from '@/assets/icons/heroIcons/Chevron-down.svg';
import { Button } from '@/components/buttons';
export const Notice = () => {
  const $ = _c(31);
  const [isOpen, setIsOpen] = useState(false);
  const controls = useAnimation();
  const {
    t
  } = useTranslation("investment");
  let t0;
  if ($[0] !== controls || $[1] !== isOpen) {
    t0 = () => {
      setIsOpen(!isOpen);
      controls.start(isOpen ? "closed" : "open");
    };
    $[0] = controls;
    $[1] = isOpen;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const toggleNotice = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconShieldExclamation />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("fees.notice.title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p className="mb-6 flex flex-row items-center justify-center gap-2 font-semibold text-orange-500">{t1}{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      open: {
        height: "auto"
      },
      closed: {
        height: "72px"
      }
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("fees.notice.text");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== controls || $[12] !== t5) {
    t6 = <motion.p animate={controls} initial="closed" variants={t4} className="overflow-hidden text-center text-gray-800">{t5}</motion.p>;
    $[11] = controls;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      open: {
        rotate: "-180deg"
      },
      closed: {
        rotate: 0
      }
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconChevronDown />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== controls) {
    t9 = <motion.span animate={controls} initial="closed" variants={t7} className="relative flex">{t8}</motion.span>;
    $[16] = controls;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isOpen || $[19] !== t) {
    t10 = isOpen ? t("fees.notice.less") : t("fees.notice.more");
    $[18] = isOpen;
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <span className="font-semibold">{t10}</span>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9 || $[25] !== toggleNotice) {
    t12 = <div className="mt-4 flex flex-row justify-center text-center"><Button testId="investmentNoticeToggle" analyticsParam="investmentNoticeToggle" onClick={toggleNotice} className="flex flex-row items-center justify-center text-blue-500" variant="unstyled" rightIcon={t9}>{t11}</Button></div>;
    $[23] = t11;
    $[24] = t9;
    $[25] = toggleNotice;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t3 || $[29] !== t6) {
    t13 = <div className="mx-auto max-w-[48rem] rounded-2xl bg-white px-4 py-6 lg:px-8">{t3}{t6}{t12}</div>;
    $[27] = t12;
    $[28] = t3;
    $[29] = t6;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};